module.exports = __webpack_public_path__ + "static/media/download_data.97c484b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/download_data.svg
// module id = 384
// module chunks = 0